var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-uesdMeetingRoom"},[_c('img',{attrs:{"src":require("@/assets/images/empty.png"),"alt":""}}),_c('div',[_vm._v(_vm._s(_vm.$t('暂无信息')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }